import styled, { css } from 'styled-components';
const footerSocialMenuItemStyles = () => css;
export const StyledFooterSocialMenuItem = styled.li `
	${footerSocialMenuItemStyles}
`;
